





























import Vue from "vue";

// Vue components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";
import CreateOrganizationDialog from "./CreateOrganizationDialog.vue";
import OrganizationCard from "./OrganizationCard.vue";

// Model
import menu from "@/store/modules/ApplicationModule/data/menu";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { GetOrganizationsCommand } from "@/model/communication/organizations/GetOrganizationsCommand";
import { Organization } from "@/model/data/organizations/Organization";
import { FolderDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
        CreateOrganizationDialog,
        OrganizationCard,
    },
    data() {
        return {
            loading: false,
            editing: false,
            deviceTreeSelectedObjectItems: [],
            organizations: [],
            showCreateOrganizationDialog: false,
            newOrganizationName: null,
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Tools").children.find((c) => c.name == "Organizations Management");
        },

        selectedFolder() {
            if (this.deviceTreeSelectedObjectItems != null && this.deviceTreeSelectedObjectItems.length == 1 && this.deviceTreeSelectedObjectItems[0].type == DeviceTreeNodeTypeEnum.Folder) return this.deviceTreeSelectedObjectItems[0];
            else return null;
        },

        organization() {
            if (this.selectedFolder != null && this.organizations != null && this.organizations.length > 0)
                if (this.organizations.some((o: Organization) => o.folderId == (this.selectedFolder as FolderDeviceTreeNode).id)) return this.organizations.filter((o: Organization) => o.folderId == (this.selectedFolder as FolderDeviceTreeNode).id)[0];
            return null;
        },
    },
    methods: {
        async getOrganizations() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new GetOrganizationsCommand().execute();
                    console.log("res", res);
                    if (res.responseStatus == ApiResponseStatusEnum.Success) this.organizations = res.organizations;
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during GetOrganizationsCommand execution: ", e);
                this.loading = false;
            }
        },

        onClosingCreateOrganizationDialog() {
            this.showCreateOrganizationDialog = false;
            this.getOrganizations();
        },
    },
    mounted() {
        this.getOrganizations();
    },
});
